<template>
  <b-popover
    :target="target"
    triggers="click blur"
    :show.sync="show"
    placement="bottom-end"
    boundary="viewport"
    :fallback-placement="[]"
    custom-class="basket-popover"
    @hidden="$emit('close')"
  >
    <template #title>
      <div class="popover-title-wrapper d-flex justify-content-between align-items-center">
        <span>Your basket <span v-if="basketCount">({{ basketCount }})</span></span>
        <button
          class="close-button d-lg-none"
          @click="$emit('close')"
          aria-label="Close basket"
        >
          <XIcon class="md-heroicon" />
        </button>
      </div>
    </template>
    <Basket class="mb-3" />
    <!-- Footer -->
    <!-- removed `fixed-bottom` to avoid Safari issues with nested position: fixed -->
    <div class="popover-footer p-3">
      <b-button
        :disabled="isBasketEmpty"
        variant="outline-primary"
        class="w-100"
        @click="goToCheckout"
      >
        Go to checkout
      </b-button>
    </div>
  </b-popover>
</template>

<script>
import { mapGetters } from 'vuex'
import { XIcon } from '@vue-hero-icons/outline'
import Basket from '@/modules/basket/components/Basket'


export default {

  name: 'BasketPopover',

  components: {
  	Basket,
  	XIcon,
  },

  props: {
  	target: String,
  	show: Boolean,
  },

  computed: {
  	...mapGetters('basket', ['isBasketEmpty', 'basketCount']),
  },

	methods: {
		goToCheckout() {
			this.$emit('close')
			this.$router.push({name: 'checkout'})
		}
	}
}
</script>

<style lang="scss">
  .basket-popover {
    width: 410px;
    max-width: calc(100vw - 30px);
    max-height: calc(100vh - 100px);
    // min-height: 200px;

    // Mobile and tablet (phone and iPad) - fixed position with close button
    @media (max-width: 991.98px) {
      width: calc(100vw - 30px) !important;
      max-width: calc(100vw - 30px) !important;
      height: calc(100vh - 30px) !important;
      max-height: calc(100vh - 30px) !important;
      position: fixed !important;
      top: 15px !important;
      bottom: 15px !important;
      left: 15px !important;
      right: 15px !important;
      transform: none !important;
      margin: 0 !important;
      
      // Hide the arrow/pointer on mobile and tablet
      .arrow {
        display: none !important;
      }
      
      // Override any placement on mobile/tablet to use full-screen positioning with margins
      &[x-placement^="top"],
      &[x-placement^="bottom"] {
        position: fixed !important;
        top: 15px !important;
        bottom: 15px !important;
        left: 15px !important;
        right: 15px !important;
        transform: none !important;
        width: calc(100vw - 30px) !important;
        height: calc(100vh - 30px) !important;
        margin: 0 !important;
      }
    }

    .popover-header {
      height: 40px;
      border: none;
      background: white;
      font-size: 26px;
      font-weight: 600;
      
      .popover-title-wrapper {
        width: 100%;
      }
      
      .close-button {
        background: none;
        border: none;
        padding: 0;
        cursor: pointer;
        color: $text-color;
        display: flex;
        align-items: center;
        justify-content: center;
        
        &:hover {
          color: $primary;
        }
        
        &:focus {
          outline: none;
        }
      }
    }

    .popover-body {
      // min-height: 160px;
      position: relative;
      display: flex;
      flex-direction: column;
      max-height: calc(100vh - 180px); // Account for header and footer
      overflow: hidden; // Prevent body from scrolling, let content scroll instead

      // Make the basket content scrollable
      > :first-child {
        flex: 1 1 auto;
        overflow-y: auto;
        overflow-x: hidden;
        min-height: 0; // Important for flex children to respect overflow
      }

      .popover-footer {
        width: 100%;
        flex-shrink: 0; // Prevent footer from shrinking
        margin-top: auto; // keeps footer at the bottom of the popover
      }
    }

    // Mobile and tablet adjustments
    @media (max-width: 991.98px) {
      .popover-body {
        max-height: calc(100vh - 30px - 40px - 80px); // Account for margins, header, and footer
        height: 100%; // Use full available height on mobile
      }
    }

  }
</style>